// 🔧 Environment Configuration
// Centralizes all environment variables with proper defaults

export const ENV = {
  // API URLs - DOCKER PRODUÇÃO PORT 3000
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:5000',
  WS_URL: import.meta.env.VITE_WS_URL || 'ws://localhost:5001',
  FRONTEND_URL: import.meta.env.VITE_FRONTEND_URL || 'http://localhost:3000', // DOCKER: PORT 3000

  // Firebase Config
  FIREBASE: {
    API_KEY: import.meta.env.VITE_FIREBASE_API_KEY || '',
    AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
    PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
    STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
    MESSAGING_SENDER_ID: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
    APP_ID: import.meta.env.VITE_FIREBASE_APP_ID || '',
    MEASUREMENT_ID: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || '',
  },

  // Security
  STORAGE_SECRET_KEY: import.meta.env.VITE_STORAGE_SECRET_KEY || 'default-secret-key',

  // Mode
  AUTH_MODE: import.meta.env.VITE_AUTH_MODE || 'firebase',
  IS_DOCKER: import.meta.env.VITE_DOCKER_ENV === 'true',
  IS_DEVELOPMENT: import.meta.env.DEV === true,
  IS_PRODUCTION: import.meta.env.PROD === true,

  // Feature Flags
  ENABLE_WEBSOCKET: import.meta.env.VITE_ENABLE_WEBSOCKET !== 'false',
  ENABLE_ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS !== 'false',
  ENABLE_DEBUG: import.meta.env.VITE_DEBUG === 'true',
};

// Helper to get full API URL
export const getApiUrl = (path: string) => {
  const base = ENV.API_URL.replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
};

// Helper to get WebSocket URL
export const getWsUrl = (path?: string) => {
  const base = ENV.WS_URL.replace(/\/$/, '');
  return path ? `${base}/${path}` : base;
};

// Validate required environment variables
export const validateEnv = () => {
  const required = [
    'VITE_API_URL',
    'VITE_FIREBASE_API_KEY',
    'VITE_FIREBASE_AUTH_DOMAIN',
    'VITE_FIREBASE_PROJECT_ID',
  ];

  const missing = required.filter(key => !import.meta.env[key]);

  if (missing.length > 0 && ENV.IS_PRODUCTION) {
    console.error('Missing required environment variables:', missing);
    throw new Error(`Missing environment variables: ${missing.join(', ')}`);
  }

  return true;
};

export default ENV;
